import { hashString } from './hash';

const FIXED_COLORS = [
  'magenta',
  'red',
  'volcano',
  'orange',
  'gold',
  'lime',
  'green',
  'cyan',
  'blue',
  'geekblue'
] as const;

function generateColor(key: string): string {
  const hash = hashString(key);
  const hue = hash % 360;
  return `hsl(${hue}, 65%, 45%)`;
}

export function getStatusColor(
  statusId: string,
  index?: number
): string {
  if (index !== undefined && index < FIXED_COLORS.length) {
    return FIXED_COLORS[index];
  }

  return generateColor(statusId);
}
